import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '@shared/services/auth.service'
import { Subscription } from 'rxjs'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { PublicPageTitleService } from '../../services/public-page-title.service'
import { faUserCircle, faUser, faSignOutAlt, faBars, faTimes } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-public-header',
  templateUrl: './public-header.component.html',
  styleUrls: ['./public-header.component.scss'],
})
export class PublicHeaderComponent implements OnInit, OnDestroy {
  isLoggedIn: boolean
  subscriptions: Subscription[] = []
  loginForm: FormGroup
  pageTitle = ''
  sideNavOpen = false
  faBars = faBars
  faTimes = faTimes

  faUserCircle = faUserCircle
  faUser = faUser
  faSignOutAlt = faSignOutAlt

  constructor(private authService: AuthService, private publicPageTitleService: PublicPageTitleService) {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required),
    })
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.authService.userLoggedinEvent.subscribe(isLoggedIn => {
        this.isLoggedIn = isLoggedIn
      })
    )

    this.isLoggedIn = this.authService.isLoggedIn()

    this.subscriptions.push(
      this.publicPageTitleService.pageTitle$.subscribe(title => {
        this.pageTitle = title
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe())
  }

  onLogout(): void {
    this.authService.logout()
  }

  toggleSideNav(): void {
    this.sideNavOpen = !this.sideNavOpen
  }
  closeSideNav(): void {
    this.sideNavOpen = false
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    if (window.innerWidth >= 992 && this.sideNavOpen) {
      this.closeSideNav()
    }
  }
}
